angular.module('unica_event_field.event_field_services')

.factory('EventFieldListService', function ($http, getBaseApiURL) {

	var eventFieldListService = {};

	eventFieldListService.list = function (eventId, limit, offset) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event-field/list/' + eventId,
			data: {
				limit: limit,
				offset: offset,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.eventFields;
			}

		});

	};

	eventFieldListService.get = function (eventFieldId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/event-field/detail/' + eventFieldId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.eventField;
			}

		});

	};

	eventFieldListService.listByInvitation = function ( eventFieldId, invitationId ) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-field/list/' + invitationId,
			data: {
				event_id: eventFieldId,
				invitation_id: invitationId
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.eventFields;
			}

		});

	};


	return eventFieldListService;
});